module.exports = __webpack_public_path__ + "static/img/home_productcard_redmud_mobile.dd36251d.jpg";